import { Box, Button, Popover, Typography } from '@mui/material';
import i18n from '../i18';
import Label from '../components/label';
import { CloseCircleCustomLinearIcon } from '../icons-lib';
import React from 'react';
import PropTypes from 'prop-types';

export const FilterPopover = ({
    children,
    anchorEl,
    setAnchorEl,
    filterCount,
    handleClearFilters,
    closeFiltersPopover,
    title,
    filterCountLabel,
    filterLabel
}) => {
    return (
        <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor={(theme) => theme.palette.borderGrey}
                backgroundColor={(theme) => theme.palette.background.default}
                p={2}
                width="320px"
                maxWidth="320px"
                overflow="hidden"
            >
                {title && <Typography variant="subtitle2">{title}</Typography>}
                {filterCountLabel && (
                    <Label
                        color={filterCount === 0 ? 'disabled' : 'primary'}
                        endIcon={
                            !!filterCount && <CloseCircleCustomLinearIcon />
                        }
                        sx={{ cursor: 'pointer', fontSize: 12 }}
                        onClick={
                            filterCount === 0
                                ? null
                                : () => handleClearFilters()
                        }
                    >
                        {filterCount} {filterCountLabel}
                    </Label>
                )}
                {filterLabel && (
                    <Label
                        color="disabled"
                        sx={{ fontSize: 12, cursor: 'pointer' }}
                        endIcon={<CloseCircleCustomLinearIcon />}
                        onClick={handleClearFilters}
                    >
                        {filterLabel}
                    </Label>
                )}
            </Box>
            {children}
            <Box
                display="flex"
                justifyContent="space-between"
                p={2}
                borderTop="1px solid"
                borderColor={(theme) => theme.palette.borderGrey}
                backgroundColor={(theme) => theme.palette.background.default}
            >
                <Button
                    variant="outlined"
                    color="secondary"
                    disabled={filterCount === 0}
                    onClick={() => {
                        handleClearFilters();
                        closeFiltersPopover();
                    }}
                >
                    {i18n.t('buttons.clear')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => closeFiltersPopover()}
                >
                    {i18n.t('buttons.done')}
                </Button>
            </Box>
        </Popover>
    );
};
FilterPopover.propTypes = {
    anchorEl: PropTypes.object || null,
    setAnchorEl: PropTypes.func.isRequired,
    closeFiltersPopover: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    filterCount: PropTypes.number,
    handleClearFilters: PropTypes.func,
    filterLabel: PropTypes.string,
    children: PropTypes.node.isRequired
};
